import * as React from 'react';
import styled from 'styled-components';

const StaticTagStyle = styled.span`
  background-color: ${props => props.theme.colorBorderSecondary};
  display: inline-block;
  padding: 0 6px;
  border-radius: ${props => props.theme.borderRadiusSM}px;
  margin-right: 8px;
`;

/**
 * Elemento grafico che ha gli stili di un Input.
 */
export interface StaticTagProps extends React.HTMLAttributes<HTMLSpanElement> {}

export function StaticTag(props: StaticTagProps) {
  return <StaticTagStyle {...props} />;
}
